export const container = `rounded z-10 text-sm h-10 data-[is-expanded=true]:!bg-primary-200`;
export const icon = `w-5 h-5`;
